import { Download } from "lucide-react";
import { PanelHeaderButton } from "@/components/common/PanelHeaderButton";

/**
 * The one way to keep an artifact, wherever its panel opens.
 *
 * A link rather than a click handler, because the server named the file when it
 * signed the URL and the `download` attribute is ignored across origins. Absent
 * until there is a URL to point at: the guard is here rather than at each call
 * site, so no host can ship a download that goes nowhere.
 */
export function ArtifactDownloadAction({ downloadUrl }: { downloadUrl?: string }) {
  if (!downloadUrl) {
    return null;
  }

  return (
    <PanelHeaderButton label="Download" href={downloadUrl}>
      <Download className="size-4" />
    </PanelHeaderButton>
  );
}
